export default __webpack_public_path__ + "static/media/12_photo.1de83d6d.jpeg";